import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {VanBanPhapQuyService} from '../../../service/info/service-vanbanphapquy';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {VanBanPhapQuy} from '../../../models/info/vanbanphapquy';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {environment} from '../../../../environments/environment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { EmitType } from '@syncfusion/ej2-base';
import {CKEditor5} from '@ckeditor/ckeditor5-angular';
import {UploaderComponent, RemovingEventArgs } from '@syncfusion/ej2-angular-inputs';
import {toNumber} from 'ngx-bootstrap/timepicker/timepicker.utils';
import {DatePipe} from '@angular/common';
import {VanBanPhapQuyFileService} from '../../../service/info/service-vanbanphapquyfile';
import {VanBanPhapQuyFile} from '../../../models/info/vanbanphapquyfile';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {EditKeHoachComponent} from '../kehoach/edit.component';
import {EditVBPQComponent} from './edit.component';
import {NavItemService} from '../../../service/staff/service-navitem';
import {Sessioncommand} from '../../../global/sessioncommand';
import {DetailVBPQComponent} from './detail.component';
import {CommandUtil} from '../../../global/commandutil';

@Component({
  templateUrl: './vanbanphapquy.component.html',
  encapsulation: ViewEncapsulation.None
})

export class VanBanPhapQuyComponent implements OnInit, AfterViewInit {
  @ViewChild('largeModal')
  public largeModal: ModalDirective;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public configToolbar: Object = environment.configToolbar;
  public frmGroup: FormGroup;
  public permission: boolean = false;
  public permissionRead: boolean = false;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public dataList: VanBanPhapQuy[];
  public submitValidate = false;
  public keyword: string = '';  
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public srSoHieuGoc: string= '';
  public srTrichYeu: string= '';
  public srNoiPhatHanh: string= '';
  constructor( public vanBanPhapQuyService: VanBanPhapQuyService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public vanBanPhapQuyFileService: VanBanPhapQuyFileService,
               public navItemService: NavItemService,
               public commandUtil: CommandUtil

  ) {
  }
  ngAfterViewInit() {
  }
  ngOnInit(): void {
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0003', true).subscribe(
      data => {this.permission = data > 0 ? true : false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0004', true).subscribe(
      data => {this.permissionRead = data > 0 ? true : false;}
    );
    this.search();

  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    const modalEdit = this.bsModalService.show(EditVBPQComponent, {class: 'modal-lg'});
    (<EditVBPQComponent>modalEdit.content).edit(
      id
    );
    (<EditVBPQComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });

  }
  detail(id: number) {
    if(this.permissionRead || this.permission) {
      const modalEdit = this.bsModalService.show(DetailVBPQComponent, {class: 'modal-lg'});
      (<DetailVBPQComponent>modalEdit.content).edit(
        id
      );
      (<DetailVBPQComponent>modalEdit.content).onClose.subscribe(result => {
        this.search();
      });
    }

  }
  search()
  {
    this.vanBanPhapQuyService.findAllByPaging(this.srSoHieuGoc,this.srTrichYeu,this.srNoiPhatHanh, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
   this.vanBanPhapQuyService.getCountByKeyword(this.srSoHieuGoc,this.srTrichYeu,this.srNoiPhatHanh).subscribe(recordCount => this.totalItems = recordCount);
  }


  deleteItem(id: number)
  {
    this.vanBanPhapQuyService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

